<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12"
                   sm="6"
                   md="4"
            >
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="computedDateFormatted"
                            label="Seleccione fecha desde la cual no se podrá agendar"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        @input="menu = false"
                        first-day-of-week="1"
                        locale="es-CL"
                        @change="changeMaxDate"
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <impersonating-nav-bar v-if="canImpersonate"></impersonating-nav-bar>
    </v-container>
</template>

<script>
import ImpersonatingNavBar from "@/components/ImpersonatingNavBar.vue";

export default {
    name: "Config",
    components: {ImpersonatingNavBar},
    data: vm => ({
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
        menu: false,
        userRoles: [],
    }),
    methods: {
        async changeMaxDate(maxDate) {
            const token = this.$store.getters.token;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/calendar-config/" + this.$store.getters.therapistId + "/set-max-date", {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token}),
                body: JSON.stringify({
                    maxDate: maxDate
                })
            });
            await response.json();
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        async changedTherapist() {
            const token = this.$store.getters.token;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/calendar-config/therapist/" + this.$store.getters.therapistId, {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token})
            });
            const responseData = await response.json();
            if (response.ok) {
                this.date = new Date(responseData.maxDate).toISOString('es-CL').substr(0, 10)
            }
            this.userRoles = this.$store.getters.userRoles;
        },
    },
    watch: {
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    created: async function () {
        const token = this.$store.getters.token;
        const response = await fetch(this.$store.getters.apiUrl + "/api/v1/calendar-config/therapist/" + this.$store.getters.therapistId, {
            method: 'POST',
            headers: new Headers({'Authorization': "Bearer " + token})
        });
        const responseData = await response.json();
        if (response.ok) {
            this.date = new Date(responseData.maxDate).toISOString('es-CL').substr(0, 10)
        }
        this.userRoles = this.$store.getters.userRoles;
    },
    mounted() {
        this.$root.$on('changedTherapist', () => {this.changedTherapist()});
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date)
        },
        canImpersonate() {
            return this.userRoles.includes("ROLE_IMPERSONATE");
        },
    },
}
</script>

<style scoped>

</style>
